// extracted by mini-css-extract-plugin
export default {"feedbackButton":"Button_feedbackButton__SU2MX"};